import { ADVERSE_EVENT_ADDED, ADVERSE_EVENT_EDITED } from 'common/messages';
import templateUrl from './adverse-event.html';

export default {
  templateUrl,
  bindings: {
    adverseEvent: '<',
    company: '<',
    animalTypes: '<',
    sexes: '<',
    states: '<',
    statuses: '<',
    symptoms: '<',
    occurrenceLikelihoods: '<',
    injuryProbabilities: '<',
    injurySeverities: '<'
  },
  controller: class AdverseEventComponent {
    constructor($mdDialog, $scope, $state,
      AdverseEventService, LoadingService,
      ToastService) {
      'ngInject';

      Object.assign(this, {
        $mdDialog,
        $scope,
        $state,
        AdverseEventService,
        LoadingService,
        ToastService
      });
    }

    $onInit() {
      this.adverseEvent.Products = this.adverseEvent.Products || [];
    }

    saveChanges() {
      const saveMessage = this.adverseEvent.AEId ? ADVERSE_EVENT_EDITED : ADVERSE_EVENT_ADDED;
      let promise;

      if (this.adverseEvent.AEId) {
        promise = this.AdverseEventService.update(this.adverseEvent);
      } else {
        promise = this.AdverseEventService.create(this.adverseEvent);
      }

      this.LoadingService.start();
      promise.then((r) => {
        this.ToastService.showSuccess(saveMessage);
        this.adverseEvent.AEId = this.adverseEvent.AEId || (r.data.Id);

        return Promise.resolve(true);
      }).then(() => this.$state.go('adverseEventEdit', { id: this.adverseEvent.AEId }, { reload: true }))
        .catch(error => this.ToastService.showError(error))
        .finally(() => this.LoadingService.stop());
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/adverse-event/adverse-event.component.js